//-----------------------------------------------
// Constants for channel Id
//-----------------------------------------------
export enum ChannelId {
    CH1 = 1,
    CH2 = 2,
    CH3_Shunt = 3,
}